import React from "react"
import { isImmutable } from "immutable"
import { mapValues } from "lodash"

export default (WrappedComponent) => (wrappedComponentProps) => {
  let propsJS = mapValues(wrappedComponentProps, (value) =>
    isImmutable(value) ? value.toJS() : value,
  )

  return <WrappedComponent {...propsJS} />
}
